module.exports = __webpack_public_path__ + "common/close-gray-8b74e41e9477d32b5a3f38e3e1235898.svg";